module.exports = __webpack_public_path__ + "static/img/bulibuli.e22cbc92.webp";